import {useSelector} from 'react-redux'

import {selectUser} from 'features/User'

interface UseSSLInspectionReleaseReturnType {
  isSSLInspectionToggleReleased: boolean
}
export const useSSLInspectionRelease =
  (): UseSSLInspectionReleaseReturnType => {
    const {primaryDomain} = useSelector(selectUser)
    const isSSLInspectionToggleReleased =
      !blockedDomainsForSSLInspectionToggleProdRelease.has(primaryDomain)

    return {isSSLInspectionToggleReleased}
  }

const blockedDomainsForSSLInspectionToggleProdRelease = new Set([
  'tjx.com',
  'infotechoutreach.onmicrosoft.com',
])
